import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { formatTime } from "@/lib/constants";
import { StatusBadge } from "@/components/StatusBadge";
import { UserAvatar } from "@/components/UserAvatar";

export const PinPopup = ({ run, address, title, base = "/manager/runs", readOnly = false }) => (
  <div className="min-w-[200px] space-y-1.5 text-slate-800" data-testid={`map-popup-${address.id}`}>
    {title && <p className="font-data text-[10px] uppercase tracking-[0.14em] text-blue-700">{title}</p>}
    <p className="text-sm font-semibold leading-snug text-slate-900">{address.full_address}</p>
    <p className="font-data text-xs font-bold text-blue-800">{address.postcode}</p>
    <StatusBadge status={address.status} />
    <dl className="grid grid-cols-[auto_1fr] gap-x-2 gap-y-0.5 pt-1 text-xs">
      {run.company_name && <><dt className="text-slate-500">Company</dt><dd className="font-semibold">{run.company_name}</dd></>}
      <dt className="text-slate-500">Locksmith</dt><dd className="flex items-center gap-1.5 font-medium">{run.locksmith.avatar_updated_at && <UserAvatar userId={run.locksmith.id} stamp={run.locksmith.avatar_updated_at} name={run.locksmith.name} className="h-5 w-5" testId={`map-popup-avatar-${address.id}`} />}{run.locksmith.name}</dd>
      <dt className="text-slate-500">Start</dt><dd className="font-data">{formatTime(run.start_time)}</dd>
      <dt className="text-slate-500">Officer</dt><dd>{run.officer || "—"}</dd>
      <dt className="text-slate-500">Run</dt><dd><StatusBadge status={run.status} /></dd>
    </dl>
    {!readOnly && <Link to={`${base}/${run.id}`} className="mt-1 inline-flex items-center gap-1 text-sm font-semibold !text-blue-700 hover:underline" data-testid={`map-popup-open-run-${address.id}`}>
      Open run <ExternalLink className="h-3.5 w-3.5" />
    </Link>}
  </div>
);
